/* eslint-disable import/prefer-default-export */
export const INPUT_DEBOUNCE_DELAY = 250;

export const LANDING_PAGE_INPUT_DEBOUNCE_DELAY = 750;
